export default __webpack_public_path__ + "media/flags/gr-bb62b9f7.svg";